import React, { ReactNode } from "react";

interface CreditCardBaseProps {
  icon: ReactNode;
  title: string;
  description: string;
  price: string;
  priceLabel: string;
  rightContent?: ReactNode;
  footerAlert?: ReactNode;
}

export const CreditCardBase: React.FC<CreditCardBaseProps> = ({
  icon,
  title,
  description,
  price,
  priceLabel,
  rightContent,
  footerAlert,
}) => {
  return (
    <div className="border-dark-100 flex w-full flex-col overflow-hidden rounded-3xl border border-solid bg-white">
      <div className="flex flex-col gap-10 p-8">
        <div className="flex items-start justify-between gap-10">
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              {icon}
              <span className="text-dark font-secondary text-xl font-semibold">
                {title}
              </span>
            </div>
            <span className="text-dark-700 font-secondary mt-2 max-w-[700px] text-sm leading-[21px] tracking-[0.14px]">
              {description}
            </span>
          </div>
          {rightContent}
        </div>

        <div className="flex items-center gap-2">
          <span className="text-dark font-secondary text-[24px] font-medium leading-[30px] tracking-[-0.2px]">
            {price}
          </span>
          <span className="text-dark-700 font-secondary text-sm leading-[21px] tracking-[-0.14px]">
            {priceLabel}
          </span>
        </div>
      </div>
      {footerAlert}
    </div>
  );
};
